import React from 'react';
import { Link } from 'react-router-dom';
import { CollectionPreferencesProps, TableProps } from '@cloudscape-design/components';
import { useProtectUtility } from '../../../components/protectedUtility';
import { Actions, ResourceTypes } from '../../../types/rolePermissions';

import { PreferenceProps } from '../../../types/table';
import { TagIcon } from '../../utilities/tagIcon';
import { TablePreferences } from '../../../utils/tablePreferences';
import { SurveyGroupListItem } from './table';

export const useTableConfig = () => {
  const protectUtility = useProtectUtility();

  const columns: TableProps.ColumnDefinition<SurveyGroupListItem>[] = [
    {
      id: 'feature',
      header: 'Survey Group',
      cell: (item) =>
        protectUtility({ resourceType: ResourceTypes.Surveys, resourceAction: Actions.Update }) ? (
          <Link to={`/surveys/edit/${item.feature}`}>{item.feature}</Link>

        ) : (
          item.feature
        ),
      sortingField: 'feature',
    },
    {
      id: 'description',
      header: 'Description',
      cell: (item) => item.description || '-',
      sortingField: 'description',
    },
    {
      id: 'tag',
      header: (
        <>
          Tag <TagIcon />
        </>
      ),
      cell: (item) => item.tag ?? '',
      sortingField: 'tag',
    },
  ];

  const defaultContentDisplayOptions: CollectionPreferencesProps.ContentDisplayOption[] = [
    { id: 'feature', label: 'Feature', alwaysVisible: true },
    { id: 'description', label: 'Description', alwaysVisible: false },
    { id: 'tag', label: 'Tag', alwaysVisible: false },
  ];

  const defaultPageSizeOptions: CollectionPreferencesProps.PageSizeOption[] = [
    { value: 10, label: '10 survey groups' },
    { value: 30, label: '30 survey groups' },
    { value: 50, label: '50 survey groups' },
  ];

  const defaultPreferences: CollectionPreferencesProps.Preferences = {
    pageSize: 10,
    contentDisplay: [
      { id: 'feature', visible: true },
      { id: 'description', visible: true },
      { id: 'tag', visible: true },
    ],
    wrapLines: false,
    stripedRows: false,
    contentDensity: 'comfortable',
    stickyColumns: { first: 1, last: 0 },
  };

  const Preferences = ({
    preferences,
    setPreferences,
    disabled = false,
    pageSizeOptions = defaultPageSizeOptions,
    contentDisplayOptions = defaultContentDisplayOptions,
  }: PreferenceProps) => <TablePreferences {...{ preferences, setPreferences, disabled, pageSizeOptions, contentDisplayOptions }} />;

  return { columns, defaultPreferences, Preferences };
};
